module.exports = __webpack_public_path__ + "static/img/addNodeIcon.a1a2d01b.png";